import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { ActivityList } from './components/activity-list';
import { DeletePlanDialog } from './components/delete-plan-dialog';
import { PlanSummary } from './components/plan-summary';
import { RestartPlanDialog } from './components/restart-plan-dialog';
import { Status } from './components/status';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { usePlanShow } from '@/data/idp/plans';
import { PlanStatus } from '@/data/idp/plans/interfaces';
import { useSetTitle } from '@/hooks/use-set-title';

export const ShowPlan = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { plan, isLoading } = usePlanShow(id!);
  useSetTitle(plan?.title ?? 'Plano sem título');

  useEffect(() => {
    if (plan?.profile_based_recommendation && plan?.description === '') {
      navigate(`/pdi/planos/novo/${plan.id}`);
    }
  }, [
    plan?.profile_based_recommendation,
    navigate,
    plan?.id,
    plan?.description,
  ]);

  const [isDeletePlanModalOpen, setIsDeletePlanModalOpen] = useState(false);
  const [isRestartPlanDialogOpen, setIsRestartPlanDialogOpen] = useState(false);

  const actions = [
    {
      label: 'Excluir plano',
      onClick: () => setIsDeletePlanModalOpen(true),
      Icon: <DeleteIcon />,
    },
  ];

  if (plan?.status == PlanStatus.Closed) {
    actions.push({
      label: 'Retomar plano',
      onClick: () => setIsRestartPlanDialogOpen(true),
      Icon: <RestoreIcon />,
    });
  }

  if (isLoading) return <PageSkeleton />;

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Voltar"
        handleBackNavigation={() => navigate('/pdi/planos')}
        actions={actions}
      />
      {plan && (
        <Stack gap={3}>
          <Stack direction={{ md: 'row' }} alignItems="flex-start" gap={7}>
            <PlanSummary plan={plan} />
            <Status
              id={id}
              status={plan?.status}
              activities={plan?.activities}
              durationInMonths={plan?.duration_in_months}
            />
          </Stack>
          <ActivityList plan={plan} activities={plan?.activities} />
        </Stack>
      )}
      {isDeletePlanModalOpen && (
        <DeletePlanDialog
          id={id!}
          onClose={() => setIsDeletePlanModalOpen(false)}
        />
      )}
      {isRestartPlanDialogOpen && (
        <RestartPlanDialog
          id={id!}
          onClose={() => setIsRestartPlanDialogOpen(false)}
        />
      )}
    </PageContainer>
  );
};
